import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { filters, headers, mobile_headers, mockRows, tabs } from "./config";

const InventoryList = () => {

  return (
    <Table tableId="inventory" title="Inventory" icon={InventoryRoundedIcon} tabs={tabs} headers={headers} mobile_headers={mobile_headers} filters={filters} defaultSort="-date_entered" idKey="inventory_id" tabField="status" exportCsv={true} />
  );
};

export default InventoryList;